import React, {Component} from 'react';
import './error.css';

class Error extends Component {
    render() {
        //IMPROVEMENT design view to improve UX
        return (
            <div className="error">
                <h1>Acceso denegado</h1>
            </div>
        );
    }
}

export default Error;
